import { render, staticRenderFns } from "./batchEnterModal.vue?vue&type=template&id=70611546&scoped=true"
import script from "./batchEnterModal.vue?vue&type=script&lang=js"
export * from "./batchEnterModal.vue?vue&type=script&lang=js"
import style0 from "./batchEnterModal.vue?vue&type=style&index=0&id=70611546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70611546",
  null
  
)

export default component.exports